export default __webpack_public_path__ + "static/media/logo-black-mobile.2eba83e0.svg";